export default "__VITE_ASSET__BTa6cNCQ__"